import React from "react";
import PropTypes from "prop-types";
import { LoadingScreenLayout } from "../layout/LoadingScreenLayout";
import { Spinner } from "../misc/Spinner";
import { useRandomMessageTransition } from "./useRandomMessageTransition";
import classNames from "classnames";
import { useMobile } from "../layout/hooks";

export function LoadingScreen({ message, infoMessages }) {
  const infoMessage = useRandomMessageTransition(infoMessages);
  const mobile = useMobile();
  // NOTE: XRStudioではこのコンポーネントの中で全部決め打ちで席目打ちで置いてしまう
  return (
    <LoadingScreenLayout
      bottom={
        <div className={classNames("tw-grid", "tw-px-6")}>
          <div
            className={classNames("tw-font-semibold", "tw-text-[#ffffff]", "tw-text-center", {
              [classNames("tw-mb-[2px]", "tw-text-base", "tw-mt-6")]: mobile,
              [classNames("tw-m-2", "tw-text-xl", "tw-mt-20")]: !mobile
            })}
          >
            {message}
          </div>
          <Spinner
            className={classNames("tw-w-full", "tw-mx-auto", {
              ["tw-max-w-[320px]"]: mobile,
              ["tw-max-w-[384px]"]: !mobile
            })}
          ></Spinner>
        </div>
      }
    />
  );
}

LoadingScreen.propTypes = {
  message: PropTypes.node,
  infoMessages: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.node.isRequired,
      message: PropTypes.node.isRequired
    })
  )
};

LoadingScreen.defaultProps = {
  infoMessages: []
};
